import styled from "styled-components";

export const StyledPersonalAuthentication = styled.div`
    background: var(--whiteAlt);
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 15px 30px 40px 0px rgba(0, 0, 0, 0.07);
    border-radius: 6px;
    padding: 20px;

    animation-duration: 0.8s;
    animation-fill-mode: both;
    position: relative;
    animation-name: kudaFadeInUp;

    @media screen and (min-width: 768px) {
        padding: 40px;
    }

    .business-account--heading {
        max-width: 205px;
        h5 {
        }
    }

    form {
        .auth-header {
            .text-xlbold {
                font-weight: 900;
            }

            .color-black {
                color: #000 !important;
            }

            p {
                font-size: 0.925rem;
                line-height: 1.5;
            }

            .text-sm {
                font-size: 0.8125rem;
            }

            .mt-3,
            .my-3 {
                margin-top: 1rem !important;
            }
        }

        .forgot-label {
            font-size: 14px;
            margin-top: 24px;
        }

        .text-semi-bold {
            font-weight: 600;
        }

        .color-black {
            color: #000 !important;
        }

        .kuda-cta {
            font-size: 16px;
            line-height: 1;
            display: flex;
            align-items: center;
            padding: 15px;
            border-radius: 4px;
            justify-content: center;
            cursor: pointer;
            background: #000000;
            border-radius: 10px;
            color: #fff;
            color: var(--whiteColor);
            height: 48px;
            transition: transform 0.6s;

            &:hover {
                transform: translate3d(0px, -3px, 0px);
            }

            span {
                pointer-events: none;
            }
        }

        .kuda-cta-md {
            max-width: 135px;
            width: 100%;
        }

        .login-button {
            margin-top: 27px;
            font-size: 1rem;
            max-width: 152px;
        }

        .kuda-form--layout {
            margin-top: 29px;

            @media only screen and (max-width: 1300px) and (min-width: 768px) {
                margin-top: 25px;
            }

            .mobile-input {
                display: flex;
                flex-direction: column;
                margin-bottom: 20px;
                position: relative;

                .formInput {
                    padding-left: 0 !important;
                    padding-right: 20px;
                    line-height: 1;
                    width: 100%;
                    padding: 20px;
                    //   margin: 20px;
                    max-height: 100%;
                    border-bottom: 1px solid rgba(219, 220, 224, 0.5) !important;
                    margin-left: 0;
                    border: none;
                    order: 0;
                    border-bottom: 1px solid rgba(219, 220, 224, 0.3);
                    outline: none;
                    padding-top: 13px;
                    padding-bottom: 15px;
                    font-weight: 700;
                    border-radius: 0;
                    background: none;

                    &.invalid {
                        border-bottom: 1px solid #f7685b !important;
                    }
                }

                .passwordToggle {
                    position: absolute;
                    right: 0;
                    top: calc(50% + 7.5px);
                    transform: translateY(-50%);
                    z-index: 999;
                    cursor: pointer;

                    svg {
                        height: auto;
                        width: 20px;
                    }
                }
            }
        }
    }

    .react-tel-input .selected-flag {
        padding-left: 12px !important;
    }
`;
